// A deterrent for casual image saving, not access control for public media.
(() => {
  const isImageSurface = (target) => {
    if (!(target instanceof Element)) return false;
    if (target.closest('img, picture')) return true;
    // Product zoom buttons overlay the image and receive pointer events.
    const media = target.closest('.product-media-container');
    return Boolean(media?.querySelector('img'));
  };

  const preventImageSave = (event) => {
    if (isImageSurface(event.target)) event.preventDefault();
  };

  // Delegation also covers images introduced by variant changes or cart updates.
  document.addEventListener('contextmenu', preventImageSave, { capture: true });
  document.addEventListener('dragstart', preventImageSave, { capture: true });
})();
